import { render, staticRenderFns } from "./modalCrearPedido.vue?vue&type=template&id=89bc2df0&scoped=true"
import script from "./modalCrearPedido.vue?vue&type=script&lang=js"
export * from "./modalCrearPedido.vue?vue&type=script&lang=js"
import style0 from "./modalCrearPedido.vue?vue&type=style&index=0&id=89bc2df0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc2df0",
  null
  
)

export default component.exports